import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import AppRoot from './app';

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>
);
